import { createSelector, MembershipsSelectors } from '../../dependencies';

export const canDeleteExpenseSelector = createSelector(MembershipsSelectors.activeMembershipRoleSelector, () => {
    // NOTE: This is intentional. Ask your BE developer or PM for more info.
    // return role !== MembershipsConsts.Roles.CONTRIBUTOR;
    return true;
});
